import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background overflow-hidden">
      {/* Starfield-like dots */}
      <div className="absolute inset-0 pointer-events-none">
        {Array.from({ length: 60 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-primary/30"
            style={{
              width: Math.random() * 3 + 1,
              height: Math.random() * 3 + 1,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `pulse ${2 + Math.random() * 4}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 3}s`,
            }}
          />
        ))}
      </div>

      <div className="text-center p-8 max-w-md relative z-10">
        <h1 className="text-8xl font-bold neon-text text-primary mb-2 tracking-widest">
          404
        </h1>
        <p className="text-2xl font-bold text-secondary neon-text-secondary mb-4">
          {t('notFound.title')}
        </p>
        <p className="text-muted-foreground mb-8">
          {t('notFound.message')}
        </p>
        <button
          onClick={() => navigate('/')}
          className="neon-button px-8 py-3 text-lg"
        >
          {t('notFound.backHome')}
        </button>
      </div>
    </div>
  );
}
